export default __webpack_public_path__ + "static/media/img-slider-cmbus-2.2cb6375e.png";